module.exports = __webpack_public_path__ + "img/221122_bimistock_image_12l.0789bbd3.png";